import type { BorrowerTask, Message } from '../types/application';

// All copy supports {{tokens}} — see utils/template.ts.

export const milestones = [
  { id: 'application', label: 'Application complete', date: 'Sep 24', detail: 'You submitted your application and selected a loan option.' },
  { id: 'submitted', label: 'Loan submitted', date: 'Sep 29', detail: 'Your file is with the lender for review.' },
  { id: 'underwriting', label: 'Underwriting', date: 'In progress', detail: 'An underwriter is verifying your income, assets, and the property. Usually 3–5 business days.' },
  { id: 'conditions', label: 'Final items', date: 'Up next', detail: 'We collect any last documents the underwriter asks for.' },
  { id: 'ctc', label: 'Clear to close', date: 'Est. Oct 21', detail: 'Your loan is fully approved and closing is scheduled.' },
  { id: 'closing', label: 'Closing', date: 'Oct 28', detail: 'Sign your final documents and get your keys.' },
];

export const currentMilestoneIndex = 2;

export const initialTasks: BorrowerTask[] = [
  {
    id: 'chase-september',
    kind: 'document',
    title: 'Upload your September {{primaryAccountName}} bank statement',
    summary: 'The underwriter needs your most recent month to confirm your down payment funds.',
    from: 'processor',
    due: 'Oct 7',
    done: false,
  },
  {
    id: 'deposit-question',
    kind: 'question',
    title: 'Tell us about a $6,000 deposit',
    summary: 'A quick note about where a recent deposit came from.',
    from: 'processor',
    due: 'Oct 7',
    done: false,
  },
  {
    id: 'appraisal-access',
    kind: 'appraisal',
    title: 'Schedule property access for the appraisal',
    summary: 'Your appraisal has been ordered. Pick a time the appraiser can visit.',
    from: 'pulse',
    due: 'Oct 9',
    done: false,
  },
  {
    id: 'title-vesting',
    kind: 'title',
    title: 'Tell us how you’d like to take title',
    summary: 'This decides whose names appear on the deed to your new home.',
    from: 'pulse',
    done: false,
  },
];

export const initialMessages: Message[] = [
  {
    id: 'm1',
    author: 'loanOfficer',
    body: 'Thanks for submitting your application, {{borrowerFirstName}}! It looks great. {{processorFirstName}} will be your processor from here.',
    time: 'Sep 24 · 4:12 PM',
  },
  {
    id: 'm2',
    author: 'processor',
    body: 'Hi {{borrowerFirstName}}, I’m {{processorFirstName}}. I’ve sent over one document request and a quick question about a deposit. Both should take about 5 minutes.',
    time: 'Oct 2 · 10:03 AM',
  },
];

export const activity = [
  { id: 'a1', kind: 'status', title: 'Your loan moved to Underwriting', time: 'Today · 9:41 AM' },
  { id: 'a2', kind: 'request', title: '{{processorFirstName}} requested your September {{primaryAccountName}} statement', time: 'Oct 2 · 10:02 AM' },
  { id: 'a3', kind: 'accepted', title: 'Driver’s license accepted', time: 'Oct 1 · 2:18 PM' },
  { id: 'a4', kind: 'status', title: 'Appraisal ordered', time: 'Sep 30 · 11:00 AM' },
  { id: 'a5', kind: 'status', title: 'Loan submitted to lender', time: 'Sep 29 · 3:30 PM' },
];

export const notificationPatterns = [
  {
    id: 'link',
    trigger: 'Secure link sent',
    channel: 'SMS',
    body: '{{brokerShortName}}: Hi {{borrowerFirstName}}, it’s {{loanOfficerFirstName}}. Here’s your secure link to finish your mortgage application — your progress saves automatically. pulse.loans/j/8Kx2q',
  },
  {
    id: 'reminder',
    trigger: 'Application reminder',
    channel: 'SMS',
    body: '{{brokerShortName}}: You’re 35% done with your application. About 12 minutes left — pick up right where you left off. pulse.loans/j/8Kx2q',
  },
  {
    id: 'requested',
    trigger: 'Document requested',
    channel: 'SMS + Email',
    body: '{{brokerShortName}}: {{processorFirstName}} needs one more document — your September {{primaryAccountName}} statement. Takes about 2 minutes. pulse.loans/j/8Kx2q',
  },
  {
    id: 'accepted',
    trigger: 'Document accepted',
    channel: 'Push',
    body: 'Your driver’s license was accepted. Nothing else needed for this item.',
  },
  {
    id: 'status',
    trigger: 'Loan status changed',
    channel: 'SMS + Email',
    body: '{{brokerShortName}}: Good news — your loan moved to Underwriting. Estimated clear to close: Oct 21.',
  },
  {
    id: 'action',
    trigger: 'Action required',
    channel: 'SMS',
    body: '{{brokerShortName}}: Please schedule a time for the appraiser to visit {{propertyStreet}} by Oct 9. pulse.loans/j/8Kx2q',
  },
];
